import { useAppDispatch, useAppSelector } from "@/store"
import React, { useEffect, useRef, useState } from "react"
import { Box, Button, Flex, Input, Text } from "@chakra-ui/react"

import { BizError } from "@/models/biz_model"
import { UserUsecase } from "@/usecases/user"
import {
  changeViewType,
  LoginApiVersion,
  LoginStatus,
  selectLoginState,
  selectUsernameInput,
  setImgCodeObj,
  setLoginApiVersion,
  updateLoginStatus,
  ViewType,
} from "@/stores/login_slice"
import { useLoginNew } from "./login_hook"
import { selectLoginPwd } from "@/stores/auth_slice"

const ImgCodeVerify: React.FC = () => {
  const imgCode = useRef<string | null>(null)
  const { msg } = useAppSelector(selectLoginState)
  const loginPwd = useAppSelector(selectLoginPwd)
  const [picPath, setPicPath] = useState("")
  const [picId, setPicId] = useState("")
  // const toast = useToast()
  const loginNew = useLoginNew()
  const userNameInput = useAppSelector(selectUsernameInput)

  const dispatch = useAppDispatch()
  const setErrMsg = (msg: string) => {
    dispatch(updateLoginStatus({ msg, status: LoginStatus.error }))
  }

  const getImgCodeHandle = async () => {
    const getImgCodeRes = await UserUsecase.getImgCode()
    if (getImgCodeRes instanceof BizError) {
      setErrMsg(getImgCodeRes.displayErrorMsg)
      return
    }
    const { picPath, captchaId } = getImgCodeRes.unwrap()

    setPicPath(picPath)
    setPicId(captchaId)
  }

  const handleConfirmPwd = async () => {
    const imgCodeStr = imgCode.current
    if (imgCodeStr === null || imgCodeStr.length === 0) {
      setErrMsg("请输入图片验证码")
      return
    }

    if (picId && imgCodeStr) {
      // 验证码校验(通过登录接口 校验图片验证码)
      const isSuccess = await loginNew({
        userName: userNameInput,
        captcha: imgCodeStr,
        captchaId: picId,
        pwd: loginPwd,
      })
      if (isSuccess) {
        // toast({
        //   title: "图片验证码 验证通过，请重新输入密码",
        //   status: "success",
        //   duration: 2000,
        //   containerStyle: {
        //     marginBottom: "210px",
        //   },
        // })
        dispatch(setImgCodeObj({ captchaId: picId, captcha: imgCodeStr }))
        dispatch(changeViewType(ViewType.login))
        dispatch(setLoginApiVersion(LoginApiVersion.newApi))
      }
    }
  }

  useEffect(() => {
    getImgCodeHandle()
  }, [])

  return (
    <Flex
      width="100vw"
      height="100vh"
      position="fixed"
      left={0}
      top={0}
      backgroundColor="rgba(0, 0, 0, 0.5)"
      justifyContent="center"
      alignItems="center"
      zIndex={9999}
    >
      <Flex
        direction="column"
        align="center"
        width="355px"
        backgroundColor="rgba(48, 49, 60, 1)"
        borderRadius="10px"
        overflow={"hidden"}
      >
        <Text color="white" fontSize="16px" margin={"25px"}>
          登录验证码
        </Text>

        <Flex width="100%" height="46px">
          <Box
            flex={1}
            backgroundColor={"white"}
            borderRadius={"6px"}
            marginLeft={"14px"}
            height={"53px"}
          >
            {picPath ? (
              <img src={picPath} alt="" />
            ) : (
              <Text textAlign={"center"} lineHeight={"53px"}>
                暂无验证码
              </Text>
            )}
          </Box>

          <Button
            flex={1}
            height={"53px"}
            variant="ghost"
            borderRadius={0}
            color="rgba(255, 255, 255, 0.7)"
            colorScheme="whiteAlpha"
            onClick={() => {
              getImgCodeHandle()
            }}
          >
            看不清，换一张
          </Button>
        </Flex>
        <Input
          marginTop={"30px"}
          width={"340px"}
          type="text"
          background="rgb(37, 38, 46)"
          color="white"
          variant="unstyled"
          paddingX="12px"
          paddingY="8px"
          _placeholder={{ color: "#999999;" }}
          fontSize="15px"
          borderRadius="8px"
          placeholder="请输入图片验证码"
          onChange={(e) => {
            imgCode.current = e.target.value.trim()
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              handleConfirmPwd()
            }
          }}
        />
        <Text color="red" fontSize="13px" marginTop="3px" height={"20px"}>
          {msg}
        </Text>
        <Flex
          width="100%"
          height="46px"
          borderTop="1px solid rgba(255, 255, 255, 0.1)"
          marginTop={"20px"}
        >
          <Button
            flex={1}
            variant="ghost"
            height="100%"
            borderRadius={0}
            color="rgba(255, 255, 255, 0.7)"
            colorScheme="whiteAlpha"
            onClick={() => {
              handleConfirmPwd()
            }}
          >
            确认
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}
export default ImgCodeVerify
